import { useFieldSave } from '@/composables/useFieldSave'
import EstateObjectsController from '@controllers/Investors/EstateObjectsController'

const propsDerivedFromTheEstateObject = ['estateObject', 'fieldStates', 'completion', 'rentalUnits']

export function useEstateObjectUpdate<TPatch extends Record<string, unknown>>(
  estateObjectId: string,
  onSaved: (savedPatch: TPatch) => void,
): (patch: TPatch) => void {
  return useFieldSave<TPatch>({
    url: EstateObjectsController.update(estateObjectId).url,
    reloadProps: propsDerivedFromTheEstateObject,
    onSaved,
  })
}
